module.exports = __webpack_public_path__ + "img/int4_rui_lag_02.2eef7a99.jpg";